"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LotteryInit = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var point_1 = require("../../model/point");
var service_1 = require("../../../library/base/service");
var LotteryInit = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(LotteryInit, _super);
    function LotteryInit() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '积分抽奖初始化';
        _this.code = '101085';
        _this.desc = '积分抽奖初始化';
        _this.requestParams = new point_1.LotteryInitRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return LotteryInit;
}(service_1.BaseService));
exports.LotteryInit = LotteryInit;
//# sourceMappingURL=lotteryInit.js.map